var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-list',{attrs:{"list":_vm.list,"columns":_vm.templateListColumns || _vm.columns,"group-actions":_vm.groupActions,"showSingleActions":_vm.isTemplate ? false : _vm.showActions,"showGroupActions":_vm.showActions && _vm.showGroupActions,"export-data-options":_vm.exportDataOptions,"showSearchbox":_vm.showSearchbox,"show-page":!_vm.isTemplate}})
}
var staticRenderFns = []

export { render, staticRenderFns }